export const CONCLUDE_ERROR = {
    MISSING_MAIN_DOCUMENT: 'missingMainDocument',
    MISSING_REQUIRED_DOCUMENTS: 'missingRequiredDocuments',
    MISSING_REVIEWER_FEEDBACK: 'missingReviewerFeedback',
    MISSING_NOTION_FIELDS: 'missingNotionFields',
    SKIP_VALIDATION_OFFER: 'skipValidationOffer',
    PLAIN_MESSAGE: 'plainMessage',
};

const hasPendencies = (data) => Array.isArray(data.pendencies) && data.pendencies.length > 0;

const KNOWN_REFUSALS = [
    { kind: CONCLUDE_ERROR.MISSING_MAIN_DOCUMENT, matches: (data) => data.code === 'DOCUMENT_MAIN_MISSING' },
    { kind: CONCLUDE_ERROR.MISSING_REQUIRED_DOCUMENTS, matches: (data) => data.code === 'DOCUMENT_REQUIRED_MISSING' && hasPendencies(data) },
    { kind: CONCLUDE_ERROR.MISSING_REVIEWER_FEEDBACK, matches: (data) => data.reason === 'REVIEWER_FEEDBACK_MISSING' },
    { kind: CONCLUDE_ERROR.MISSING_NOTION_FIELDS, matches: (data) => data.reason === 'NOTION_REQUIRED_FIELDS_MISSING' },
    { kind: CONCLUDE_ERROR.SKIP_VALIDATION_OFFER, matches: (data) => !!data.skipValidationInfo },
];

export const resolveConcludeError = (data) =>
    (KNOWN_REFUSALS.find(refusal => !!data && refusal.matches(data)) || { kind: CONCLUDE_ERROR.PLAIN_MESSAGE }).kind;
